export const secretTypesConstants = {
	Credentials: 1,
	DatabaseCredentials: 2,
	WebCredentials: 3,
	CreditCards: 4,
	SunatCredentials: 5,
	BankAccounts: 6,
	BankDetractionAccounts: 7
};

// Función para obtener los tipos de secretos con traducciones
export const getSecretTypes = (t) => [
	{
		value: secretTypesConstants.Credentials,
		label: t('enums.secretTypes.Credentials'),
		enumFilter: "'Credentials'"
	},
	{
		value: secretTypesConstants.DatabaseCredentials,
		label: t('enums.secretTypes.DatabaseCredentials'),
		enumFilter: "'DatabaseCredentials'"
	},
	{
		value: secretTypesConstants.WebCredentials,
		label: t('enums.secretTypes.WebCredentials'),
		enumFilter: "'WebCredentials'"
	},
	{
		value: secretTypesConstants.CreditCards,
		label: t('enums.secretTypes.CreditCards'),
		enumFilter: "'CreditCards'"
	},
	{
		value: secretTypesConstants.SunatCredentials,
		label: t('enums.secretTypes.SunatCredentials'),
		enumFilter: "'SunatCredentials'"
	},
	{
		value: secretTypesConstants.BankAccounts,
		label: t('enums.secretTypes.BankAccounts'),
		enumFilter: "'BankAccounts'"
	},
	{
		value: secretTypesConstants.BankDetractionAccounts,
		label: t('enums.secretTypes.BankDetractionAccounts'),
		enumFilter: "'BankDetractionAccounts'"
	}
];

// Función para obtener las monedas con traducciones
export const getCurrencies = (t) => [
	{
		value: 0,
		label: t('enums.currencies.All'),
		enumFilter: "'All'"
	},
	{
		value: 1,
		label: t('enums.currencies.Soles'),
		enumFilter: "'Pen'"
	},
	{
		value: 2,
		label: t('enums.currencies.AmericanDollars'),
		enumFilter: "'Usd'"
	},
	{
		value: 3,
		label: t('enums.currencies.Euros'),
		enumFilter: "'Eur'"
	}
];

// Función para obtener los tipos de tarjeta con traducciones
export const getCardTypes = (t) => [
	{
		value: 1,
		label: t('enums.cardTypes.Credit'),
		enumFilter: "'Credit'"
	},
	{
		value: 2,
		label: t('enums.cardTypes.Debit'),
		enumFilter: "'Debit'"
	}
];

// Mantener las versiones estáticas para compatibilidad hacia atrás
export const secretTypes = [
{
	value: secretTypesConstants.Credentials,
	label: "Credentials",
	enumFilter: "'Credentials'"
},
{
	value: secretTypesConstants.DatabaseCredentials,
	label: "Database Credentials",
	enumFilter: "'DatabaseCredentials'"
},
{
	value: secretTypesConstants.WebCredentials,
	label: "Web Credentials",
	enumFilter: "'WebCredentials'"
},
{
	value: secretTypesConstants.CreditCards,
	label: "Tarjetas de Crédito",
	enumFilter: "'CreditCards'"
},
{
	value: secretTypesConstants.SunatCredentials,
	label: "Credenciales SUNAT",
	enumFilter: "'SunatCredentials'"
},{
	value: secretTypesConstants.BankAccounts,
	label: "Cuentas Bancarias",
	enumFilter: "'BankAccounts'"
},
{
	value: secretTypesConstants.BankDetractionAccounts,
	label: "Cuentas Bancarias Detracción",
	enumFilter: "'BankDetractionAccounts'"
}];

export const currencies = [
	{
		value: 0,
		label: "All",
		enumFilter: "'All'"
	},
	{
		value: 1,
		label: "Soles",
		enumFilter: "'Pen'"
	},
	{
		value: 2,
		label: "American Dollars",
		enumFilter: "'Usd'"
	},
	{
		value: 3,
		label: "Euros",
		enumFilter: "'Eur'"
	}];

export const cardTypes = [
	{
		value: 1,
		label: "Credit",
		enumFilter: "'Credit'"
	},
	{
		value: 2,
		label: "Debit",
		enumFilter: "'Debit'"
	}];